var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2793 1.47998H18.7093V8.18998H5.2793V1.47998Z",
    stroke: "#55489E",
    strokeWidth: 1.92,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2793 8.19H18.7093V14.9H5.2793V8.19Z",
    stroke: "#55489E",
    strokeWidth: 1.92,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2793 14.91H18.7093V21.62H5.2793V14.91Z",
    stroke: "#55489E",
    strokeWidth: 1.92,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.709 4.35999C19.7257 4.35998 20.7009 4.76318 21.4207 5.48116C22.1406 6.19914 22.5463 7.17329 22.549 8.18998C22.5411 9.20321 22.133 10.1722 21.4137 10.8859C20.6944 11.5996 19.7222 12 18.709 12",
    stroke: "#55489E",
    strokeWidth: 1.92,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.709 12C19.7274 12 20.7041 12.4046 21.4243 13.1247C22.1444 13.8448 22.549 14.8216 22.549 15.84C22.549 16.3438 22.4496 16.8427 22.2565 17.308C22.0634 17.7733 21.7804 18.196 21.4237 18.5518C21.067 18.9075 20.6436 19.1894 20.1777 19.3813C19.7119 19.5732 19.2128 19.6713 18.709 19.67",
    stroke: "#55489E",
    strokeWidth: 1.92,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.27943 19.7C4.77609 19.7013 4.27746 19.6032 3.81219 19.4111C3.34692 19.2191 2.92418 18.9371 2.56827 18.5812C2.21236 18.2253 1.93029 17.8025 1.73828 17.3372C1.54627 16.872 1.44811 16.3733 1.44943 15.87C1.44414 15.3637 1.5393 14.8613 1.72941 14.392C1.91951 13.9227 2.20079 13.4958 2.55697 13.1359C2.91314 12.776 3.33715 12.4903 3.80445 12.2953C4.27176 12.1003 4.77308 12 5.27943 12",
    stroke: "#55489E",
    strokeWidth: 1.92,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.27922 12C4.2669 12 3.29574 11.5992 2.57805 10.8853C1.86035 10.1713 1.45451 9.20229 1.44922 8.18998C1.44922 7.17421 1.85274 6.20003 2.571 5.48177C3.28926 4.7635 4.26344 4.35999 5.27922 4.35999",
    stroke: "#55489E",
    strokeWidth: 1.92,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16016 4.35999H10.0802",
    stroke: "#55489E",
    strokeWidth: 1.92,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16016 11.07H10.0802",
    stroke: "#55489E",
    strokeWidth: 1.92,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16016 17.78H10.0802",
    stroke: "#55489E",
    strokeWidth: 1.92,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8292 4.35999H12.9492",
    stroke: "#55489E",
    strokeWidth: 1.92,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8292 11.07H12.9492",
    stroke: "#55489E",
    strokeWidth: 1.92,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8292 17.78H12.9492",
    stroke: "#55489E",
    strokeWidth: 1.92,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildType);
export default __webpack_public_path__ + "static/media/build-type.42e89efe.svg";
export { ForwardRef as ReactComponent };